// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","lds-ring":"Spinner_lds-ring__dTAWm"};